import React from "react";
import UserInputItem from "./UserInputItem";
import UserInputItemExtraField from "./UserInputItemExtraField";

const UserInput = (props) => {
  if (props.type === "matrixField") {
    return (
      <>
        <div
          className={
            `inb-form-group column medium-${props.mediumWidth ? props.mediumWidth : "4"} small-12 ` +
            props.value.name
          }
        >
          <label className="inb-form__controlLabel">
            {props.value.display_name}
            {props.value.required_be ? "*" : ""}{" "}
          </label>
          <div className="inb-form__controllClass">
            <UserInputItem
              value={props.value}
              name={props.name}
              formError={props.formError}
              disabled={props.disabled}
              val={props.val}
              placeholder={props.placeholder}
              onChangeForm={props.onChangeForm}
              getAvailableRoles={props.getAvailableRoles}
              getAvailableTypeRecipient={props.getAvailableTypeRecipient}
              getAvailableTypeNotification={props.getAvailableTypeNotification}
            />
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        <div
          className={
            `inb-form-group column medium-${props.mediumWidth ? props.mediumWidth : "4"} small-12 ` +
            props.value.name
          }
        >
          <label className="inb-form__controlLabel">
            {props.value.display_name}
            {props.value.required_be ? "*" : ""}
          </label>
          <div className="inb-form__controllClass">
            <UserInputItemExtraField
              value={props.value}
              name={props.name}
              formError={props.formError}
              disabled={props.disabled}
              val={props.val}
              placeholder={props.placeholder}
              onChangeForm={props.onChangeForm}
              getAvailableRoles={props.getAvailableRoles}
              getAvailableTypeRecipient={props.getAvailableTypeRecipient}
              getAvailableTypeNotification={props.getAvailableTypeNotification}
            />
          </div>
        </div>
      </>
    );
  }
};
export default UserInput;
